import React from 'react';
import { X } from 'lucide-react';

interface ProblemStatementModalProps {
    isOpen: boolean;
    onClose: () => void;
    statement: string;
}

const ProblemStatementModal: React.FC<ProblemStatementModalProps> = ({ isOpen, onClose, statement }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex pointer-events-none">
            {/* Background overlay with very small blur */}
            <div
                className="absolute inset-0 bg-black/5 backdrop-blur-[1px] pointer-events-auto"
                onClick={onClose}
            ></div>

            <div
                className="absolute pointer-events-auto bg-white overflow-hidden flex animate-in slide-in-from-top-4 fade-in duration-300 shadow-[0_10px_40px_rgba(0,0,0,0.15)]
                w-[90%] md:w-[746px] 
                h-auto md:min-h-[314.3px] 
                top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                rounded-[9.27px] border-[0.77px] border-[#E2E8F0]"
            >
                {/* Left Teal Gradient Strip */}
                <div className="w-[12px] bg-gradient-to-b from-[#347468] via-[#4A9285] to-[#7BC2B5] h-full flex-shrink-0"></div>

                <div className="flex-1 p-[32px] flex flex-col">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-[20px] right-[24px] w-[28px] h-[28px] rounded-full bg-[#347468] flex items-center justify-center text-white hover:bg-[#2a5d54] transition-all z-10"
                    >
                        <X size={14} strokeWidth={3} />
                    </button>

                    {/* Header Section */}
                    <div className="flex items-center gap-[12px] mb-[20px]">
                        <div className="w-[18px] h-[18px] flex-shrink-0">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="7" cy="7" r="5.5" stroke="#347468" strokeWidth="1.5" />
                                <path d="M7 4.5v3l2 1.5" stroke="#347468" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <h2 className="text-[20px] font-bold text-[#347468] leading-none">Pod Description</h2>
                    </div>

                    {/* Content Section */}
                    <div className="flex flex-col flex-1 overflow-y-auto pr-2 max-h-[60vh]">
                        <p className="text-[#64748B] text-[15.5px] font-medium leading-relaxed text-justify whitespace-pre-line">
                            {statement || 'No problem statement defined.'}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProblemStatementModal;
